// src/UserMessagePage.js
import React, { useEffect, useState } from 'react';
// import axios from 'axios';
import axios from "./axiosConfig";
import './UserMessagePage.css';
import { useLocation, useNavigate } from 'react-router-dom';

function UserMessagePage() {
  const [messages, setMessages] = useState([]);
  const [content, setContent] = useState('');
  const [hasUnread, setHasUnread] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  const currentUser = JSON.parse(localStorage.getItem('user'));
  const isAdmin = currentUser?.role === 'admin';

  // When admin: we get receiverId (user)
  const receiverId = isAdmin ? location.state?.userId : 21; // 21 = admin ID
  const receiverName = isAdmin ? location.state?.userName : 'Admin';
  const fromPage = location.state?.fromPage || '/dashboard';

  const fetchMessages = async () => {
    try {
      // const res = await axios.get('http://localhost:8080/api/admin-messages/conversation', {
      //   params: {
      //     user1Id: currentUser.id,
      //     user2Id: receiverId
      //   }
      // });

      const res = await axios.get('/api/admin-messages/conversation', {
        params: {
          user1Id: currentUser.id,
          user2Id: receiverId
        }
      });
      setMessages(res.data);

      // Mark as read (if needed)
      // await axios.put('http://localhost:8080/api/admin-messages/mark-read', null, {
      //   params: {
      //     senderId: receiverId,
      //     receiverId: currentUser.id
      //   }
      // });
      await axios.put('/api/admin-messages/mark-read', null, {
        params: {
          senderId: receiverId,
          receiverId: currentUser.id
        }
      });
    } catch (err) {
      console.error(err);
      setError('Failed to load messages.');
    } finally {
      setLoading(false);
    }
  };

  const checkUnread = async () => {
    try {
      // const res = await axios.get(`http://localhost:8080/api/admin-messages/unread?receiverId=${currentUser.id}`);
      const res = await axios.get(`/api/admin-messages/unread?receiverId=${currentUser.id}`);
      if (res.data.length > 0) {
        setHasUnread(true);
      }
    } catch (err) {
      console.error('Unread check failed', err);
    }
  };

  const handleSend = async () => {
    if (!content.trim()) return;
    try {
      // await axios.post(`http://localhost:8080/api/admin-messages/send`, content, {
      await axios.post(`/api/admin-messages/send`, content, {
        params: {
          senderId: currentUser.id,
          receiverId: receiverId
        },
        headers: { 'Content-Type': 'text/plain' }
      });
      setContent('');
      fetchMessages();
    } catch (err) {
      console.error(err);
      setError('Failed to send message.');
    }
  };

  useEffect(() => {
    fetchMessages();
    checkUnread();
    const interval = setInterval(fetchMessages, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="user-message-container">
      <h2>
        📬 Messages with {receiverName}
        {hasUnread && <span className="notification-dot">🔴</span>}
      </h2>

      <button className="back-button" onClick={() => navigate(fromPage)}>
        ← Back
      </button>

      {loading ? (
        <p>Loading messages...</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : (
        <>
          <div className="message-box">
            {messages.map((msg) => (
              <div
                key={msg.id}
                className={`message ${msg.sender.id === currentUser.id ? 'sent' : 'received'}`}
              >
                <div className="message-content">{msg.content}</div>
              </div>
            ))}
          </div>

          <div className="chat-input">
            <input
              type="text"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Type your message..."
            />
            <button onClick={handleSend}>Send</button>
          </div>
        </>
      )}
    </div>
  );
}

export default UserMessagePage;
